<div class="lm-facade-fields-content scrollable-y">
@if (data().length > 0) {
    @for(facadeComponent of data(); let i = $index; track facadeComponent.name) {
      <div class="lm-facade-field-wrapper">
        <div class="lm-facade-field-icon-label">
          <svg soho-icon class="lm-facade-field-icon" [icon]="facadeComponent.icon" soho-tooltip [content]="facadeComponent.textTooltip"/>
            <p class="facade-field-label" soho-tooltip [title]="facadeComponent.name" [content]="facadeComponent.tooltip" [popover]="true" [placement]="'left'" >{{facadeComponent.displayName ? facadeComponent.displayName : facadeComponent.name }}</p>
        </div>
<!--        <svg class="lm-facade-info-icon" soho-icon [icon]="'info'"-->
<!--           soho-tooltip-->
<!--           [popover]="true"-->
<!--           [title]="propertiesTooltip"-->
<!--           [placement]="'left'"-->
<!--           [trigger]="'click'"-->
<!--           (click)="showDetails(facadeComponent, i)"/>-->
      </div>
    }
} @else {
    <div class="empty-title"><span>{{'Facade_NoDataMsg' | translate: label()}}</span></div>
}
</div>

